import { Grid, Typography } from "@mui/material";
import { AddServiceButton } from "./shoppingCartStyles";
import { useTranslation } from "react-i18next";
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { appStyleMode } from "../../helpers/clientConfigs";
import { AppStyle } from "../../helpers/appStyle";
import { useRouteNavigator } from "../../routes/useRouteNavigator";

export function CartServicesEmpty() {
  const routeNavigator = useRouteNavigator();
  const { t } = useTranslation('payment');
  const addServiceClick = () => {
    if (appStyleMode === AppStyle.Mobile)
      routeNavigator.goHome();
    else
      routeNavigator.goToSearch();
  }

  return (
    <Grid
      className={appStyleMode === AppStyle.Mobile && "shopping-cart-services-empty-list"}
      sx={{
        height: appStyleMode !== AppStyle.Mobile ? "270px" : null,
        color: "#b5b5b5"
      }}
      container
      direction="column"
      justifyContent="center"
      alignItems="center">
      <SentimentDissatisfiedIcon
        sx={{
          height: "50px",
          width: "50px"
        }} />
      <Typography sx={{ fontStyle: "italic", fontSize: "30px", fontWeight: "lighter" }}>{t('emptyCart')}</Typography>
      <AddServiceButton variant="contained" onClick={addServiceClick}>{t('add')}</AddServiceButton>
    </Grid>
  );
}